import { render, staticRenderFns } from "./GeneralProductStatementSelect.vue?vue&type=template&id=779d7cd9&"
import script from "./GeneralProductStatementSelect.vue?vue&type=script&lang=js&"
export * from "./GeneralProductStatementSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports